export const nav = {
    permission: 'ata.budgets:ver',
    section: 'Settings',
    title: 'Budgets',
    icon: 'account_balance_wallet',
    route: '/budgets',
    sequence: 25,
};

export default [
    {
        path: '/budgets',
        name: 'budgets',
        component: () => import('./pages/BudgetsPage.vue'),
        meta: { requiresAuth: true, permission: 'ata.budgets:ver' },
    },
];
